import { z } from 'zod'
import { lowerHexSchema } from '../../types/primitive'
import type { TransactionIndex } from '../../types/transactionIndex'
import type { HeadersInput } from '../types'
import type { RoutescanClient } from './client'

type GetListOfErc721TokenTransferEventsByAddressParameters = {
  client: RoutescanClient
  address: string
  startblock?: number
  endblock?: number
  page?: number
  offset?: number
  sort?: 'asc' | 'desc'
  headers?: HeadersInput
}

const transferSchema = z.object({
  blockNumber: z.string().regex(/^\d+$/).transform(Number),
  hash: lowerHexSchema,
  timeStamp: z.string().regex(/^\d+$/).transform(Number),
})
const resultSchema = z.array(transferSchema)

/** {@link https://docs.etherscan.io/routescan/api-endpoints/accounts#get-a-list-of-erc721-token-transfer-events-by-address} */
export const getListOfErc721TokenTransferEventsByAddress = async ({
  client,
  address,
  startblock = 0,
  endblock,
  page = 1,
  offset = 10_000,
  sort = 'asc',
  headers,
}: GetListOfErc721TokenTransferEventsByAddressParameters): Promise<
  TransactionIndex[]
> => {
  try {
    const result = await client.get({
      path: '',
      query: {
        module: 'account',
        action: 'tokennfttx',
        address,
        startblock: startblock.toString(),
        ...(endblock === undefined
          ? {}
          : {
              endblock: endblock.toString(),
            }),
        page: page.toString(),
        offset: offset.toString(),
        sort,
      },
      resultSchema,
      headers,
    })
    return result.map((v) => ({
      blockNumber: v.blockNumber,
      hash: v.hash,
      timestamp: v.timeStamp * 1000,
    }))
  } catch (error) {
    if (
      error instanceof Error &&
      (error.message === 'No transactions found' ||
        error.message === 'No records found')
    ) {
      return []
    }
    throw error
  }
}
